// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"173":"d6e17252","587":"c280c5b6","722":"90f2e8ff","761":"e17d853d","795":"14bce795"}[chunkId] + ".chunk.css";
};